import { render, staticRenderFns } from "./LdpDanhGia.vue?vue&type=template&id=090c55ba&scoped=true&"
import script from "./LdpDanhGia.vue?vue&type=script&lang=js&"
export * from "./LdpDanhGia.vue?vue&type=script&lang=js&"
import style0 from "./LdpDanhGia.vue?vue&type=style&index=0&id=090c55ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c55ba",
  null
  
)

export default component.exports